'use es6';

import { postNotification, removeNotification } from 'ReduxMessenger/actions/NotificationActions'; // Wrapper around ReduxMessenger for cases where it's not possible
// to use an existing redux action and postNotification is too low level

const DEFAULT_NOTIFICATION_TIMEOUT = 3000; // 3 seconds for small messages

export const postTimedNotification = (notification, timeout) => {
  return dispatch => {
    dispatch(postNotification(notification));

    if (notification.id) {
      setTimeout(() => dispatch(removeNotification(notification.id)), timeout || DEFAULT_NOTIFICATION_TIMEOUT);
    }
  };
};